import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { NGXLogger as LoggerService } from "ngx-logger";

import { ResponsiveService } from '../services/responsive.service';
import { TranslationGeneralService } from '../translation/translation.general.service';
import { UIMesageService } from '../services/ui-message.service';
import { AuthService } from '../../user/auth.service';
import { UserService } from '../../user/user.service';
import { NavigationService } from '../../whoo/core/navigation.service';
import { PollService } from '../../whoo/core/poll.service';
import { AuthErrorService } from '../../user/auth-error.service';
import { TranslateMigratedPipe } from '../translation/trans-migrated.pipe';
import { LanguageMenuComponent } from '../language-menu/language-menu.component';
import { UserVoteService } from '../../whoo/features/vote/user-vote.service';
import { HeaderService } from '../../whoo/shared/poll-header/header.service';
import { RouteContextService } from '../services/route-context.service';

export interface DialogData {
    animal: string;
    name: string;
}

@Component({
    selector: 'nav-menu-button',

    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        MatMenuModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        TranslateMigratedPipe,
        LanguageMenuComponent
    ],

    templateUrl: './menu-button.component.html',
    styleUrls: ['./menu-button.component.scss'],
})
export class NavMenuButtonComponent {
    @Input() showGoToResponses: boolean = false;
    @Input() showGoToVote: boolean = false;
    @Input() color: string = 'XX';

    public qrCode: string = null;

    constructor(
        public authService: AuthService,
        public userService: UserService,
        public responsiveService: ResponsiveService,
        public trans: TranslationGeneralService,
        private logger: LoggerService,
        public navigationService: NavigationService,
        private uiMessage: UIMesageService,
        public pollService: PollService,
        private authErrorService: AuthErrorService,
        private userVoteService: UserVoteService,
        public headerService: HeaderService,
        public routeContextService: RouteContextService

    ) { }

    navigateToChoosePollTemplate(): void {
        this.navigationService.navigateChoosePollTemplate();
    }


    async logout() {
        try {
            this.logger.log('logout');

            this.userVoteService.isLoggingOut = true
            await this.navigationService.navigate(this.trans.getRoutePath('userLogin'));
            this.pollService.unInitializePoll();
            await this.authService.logOut();
            this.uiMessage.success(this.trans.translate('logout.success'));
            this.userVoteService.isLoggingOut = false

        } catch (error) {
            this.authErrorService.handleError(error)

        }
    }
}
